import socket from '../../socket.js';
import {useDevice} from '../../Dashboard/DeviceContext'


import {useState,useEffect} from 'react';


function DeviceSelector() {


const phone=localStorage.getItem ('phone');


    const [open, setOpen] = useState(false);

    const {selectedDevice, setSelectedDevice} = useDevice({
    unit_name:"sibil"
    });

     const [devices,setDevices] = useState([]);
/*
    const devices = [

        {
            id: "MG-1001",
            name: "سالن اصلی",
            status: "online"
        },

        {
            id: "MG-1002",
            name: "VIP",
            status: "online"
        },

        {
            id: "MG-1003",
            name: "طبقه دوم",
            status: "offline"
        }

    ];
*/
    useEffect (()=>{
      socket.emit ('get_units',{phone:phone});
      socket.on ('your_units',(data)=>{
        if (data[0]!=undefined)
          setDevices  (data);
      })
    },[]);

    function selectDevice(device){

        setSelectedDevice(device);
        setOpen(false);
        socket.emit ('getNumberOfGame',device);
        // بعداً اینجا API را صدا می‌زنیم
        // تا اطلاعات دستگاه جدید دریافت شود

    }



    return (

        <div className="relative">


            <button

                onClick={()=>setOpen(!open)}

                className="
                bg-slate-800
                border
                border-slate-700
                rounded-xl
                px-5
                py-3
                flex
                items-center
                gap-3
                hover:border-cyan-400
                transition
                "

            >

                <div className="text-right">

                    <p className="text-gray-400 text-sm">

                  {"دستگاه "}

                    </p>


                    <p className="text-cyan-400 font-bold">

                    {(selectedDevice!=undefined && selectedDevice.unit_name!=undefined)?selectedDevice.unit_name:null}

                    </p>

                </div>


                <span className="text-gray-400">

                    ▼

                </span>


            </button>



            {

            open &&

            (

            <div

            className="
            absolute
            left-0
            mt-2
            w-64
            bg-slate-900
            border
            border-slate-700
            rounded-xl
            shadow-xl
            z-50
            overflow-hidden
            "

            >


            {

            devices.map((device)=>(


                <button

                key={device.id}

                onClick={()=>{
                    selectDevice(device);
                    socket.emit ('get_package',device); 
                    socket.emit ('getNumberOfGame',device);
                }}

                className="
                w-full
                px-5
                py-4
                flex
                justify-between
                items-center
                hover:bg-slate-800
                transition
                "

                >


                <div className="text-right">

                    <p className="text-white">

                    {device.unit_name}

                    </p>


                    <p className="text-gray-400 text-sm">
                    {"شارژ : "+device.unit_charge}


                    </p>

                </div>



                <span>

                {

                device.online===true

                ?

                "🟢"

                :

                "🔴"

                }

                </span>


                </button>


            ))

            }


            </div>

            )

            }


        </div>

    );

}


export default DeviceSelector;
